/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { BrandColors } from '@blend/enterprise-components';
// Ref. https://git.blendlabs.com/blend/cb-platform-ui/blob/main/packages/layouts/src/themes/blend-ent.ts
export const theme = {
  anchor: {
    color: 'sky',
    textDecoration: 'underline'
  },
  button: {
    border: {
      radius: '3px'
    },
    default: {
      background: 'white',
      border: {
        width: '1px'
      },
      color: 'night'
    },
    hover: {
      default: {
        background: {
          color: 'button-hover'
        },
        border: {
          color: 'button-border'
        }
      },
      primary: {
        background: {
          color: 'skyTone30'
        },
        color: 'white'
      },
      secondary: {
        background: {
          color: 'skyTone45'
        },
        border: {
          color: 'accentSky07'
        }
      }
    },
    padding: {
      horizontal: '24px',
      vertical: '8px'
    },
    primary: {
      background: 'sky',
      border: {
        width: '1px'
      },
      color: 'white',
      font: {
        weight: 400
      }
    },
    secondary: {
      background: 'white',
      border: {
        color: 'sky',
        width: '1px'
      },
      color: 'sky',
      font: {
        weight: 400
      }
    },
    size: {
      medium: {
        border: {
          radius: '3px'
        },
        pad: {
          horizontal: '24px',
          vertical: '10px'
        }
      }
    }
  },
  formField: {
    border: false,
    label: {
      margin: {
        horizontal: 'none'
      }
    }
  },
  global: {
    colors: {
      accentGreen: BrandColors.ACCENT_GREEN,
      accentGreen07: BrandColors.ACCENT_GREEN_07,
      accentGreenDark: BrandColors.ACCENT_GREEN_DARK,
      accentRed: BrandColors.ACCENT_RED,
      accentRed07: BrandColors.ACCENT_RED_07,
      accentSky07: BrandColors.ACCENT_SKY_07,
      accentYellow70: BrandColors.ACCENT_YELLOW_70,
      accentYellowDark: BrandColors.ACCENT_YELLOW_DARK,
      backgroundGrey: BrandColors.BACKGROUND_GREY,
      cloud10: BrandColors.CLOUD_10,
      cloud30: BrandColors.CLOUD_30,
      cloud50: BrandColors.CLOUD_50,
      cloud70: BrandColors.CLOUD_70,
      night: BrandColors.NIGHT,
      night60: BrandColors.NIGHT_60,
      night90: BrandColors.NIGHT_90,
      sky: BrandColors.SKY,
      skyTone30: BrandColors.SKY_TONE_30,
      skyTone45: BrandColors.SKY_TONE_45,
      text: BrandColors.NIGHT_80,
      white: BrandColors.WHITE,
      alert: '#EDCA57',
      error: '#CC4452',
      info: '#303030',
      inverse: '#48607A',
      positive: '#60BD80',
      'alert-text': '#493C16',
      'error-text': '#FFFFFF',
      'info-text': '#FFFFFF',
      'inverse-text': '#FFFFFF',
      'positive-text': '#1C3757'
    },
    debounceDelay: 0,
    // used in field validation
    edgeSize: {
      hair: '2px',
      large: '32px',
      medium: '24px',
      small: '16px',
      xlarge: '40px',
      xsmall: '8px',
      xxsmall: '4px'
    },
    elevation: {
      light: {
        medium: '0px 1px 4px rgba(0, 0, 0, 0.12)'
      }
    },
    focus: {
      outline: {
        color: 'sky'
      }
    },
    font: {
      family: 'Roboto, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, Arial, sans-serif',
      height: '1.5rem',
      size: '0.875rem'
    },
    input: {
      font: {
        size: 'medium',
        weight: 'normal'
      }
    }
  },
  heading: {
    level: {
      2: {
        font: {
          weight: 500
        },
        small: {
          height: '28px',
          size: '24px'
        }
      },
      4: {
        font: {
          weight: 500
        },
        medium: {
          height: '21px',
          size: '18px'
        }
      },
      5: {
        font: {
          weight: 400
        },
        medium: {
          height: '18px',
          size: '12px'
        }
      }
    }
  },
  radioButton: {
    check: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      color: BrandColors.SKY
    },
    color: BrandColors.SKY,
    hover: {
      border: {
        color: BrandColors.SKY
      }
    }
  },
  text: {
    large: {
      height: '24px',
      size: '16px'
    },
    medium: {
      height: '21px',
      size: '14px'
    },
    small: {
      height: '18px',
      size: '12px'
    }
  }
};